import { render, staticRenderFns } from "./user_app_settings.vue?vue&type=template&id=7add1dc8&scoped=true&"
import script from "./user_app_settings.vue?vue&type=script&lang=js&"
export * from "./user_app_settings.vue?vue&type=script&lang=js&"
import style0 from "./user_app_settings.vue?vue&type=style&index=0&id=7add1dc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7add1dc8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7add1dc8')) {
      api.createRecord('7add1dc8', component.options)
    } else {
      api.reload('7add1dc8', component.options)
    }
    module.hot.accept("./user_app_settings.vue?vue&type=template&id=7add1dc8&scoped=true&", function () {
      api.rerender('7add1dc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/shared/user/header_block/user_app_settings.vue"
export default component.exports